export default __webpack_public_path__ + "static/media/Album cover of Fairy Wind for PR and website.db31a050.jpg";